module.exports = __webpack_public_path__ + "static/lakes-40e7e5774a325f22138330cf9bd02e07.jpg";